import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FlexCol, FlexRow, Spacer } from '../../common/components/v2';
import { QaSection, SearchInput } from './components';
import { useQaSections } from './hooks';
import styles from './styles.module.scss';

const QeInterviewQa = () => {
  const { policyId } = useParams<{ policyId: string }>();

  const parsedPolicyId = Number(policyId);
  const { qaSections } = useQaSections(parsedPolicyId);
  const [query, setQuery] = useState('');

  return (
    <div className={styles.Layout}>
      <FlexRow className={styles.Header}>
        <FlexCol xs={10}>
          <Typography variant="h2" color="textPrimary">
            Application Questions and Answers
          </Typography>
          <Spacer height={4} />
          <Typography variant="h3" color="textSecondary">
            {`Policy Number: ${parsedPolicyId}`}
          </Typography>
        </FlexCol>
        <FlexCol xs={2}>
          <SearchInput value={query} onChange={setQuery} />
        </FlexCol>
      </FlexRow>
      <Spacer height={24} />
      <FlexRow>
        <FlexCol className={styles.Sections} xs={12}>
          {qaSections.map((qaSection, index) => (
            <QaSection query={query} key={index} section={qaSection} />
          ))}
        </FlexCol>
      </FlexRow>
      <Spacer height={24} />
    </div>
  );
};

export default QeInterviewQa;
